module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-14.92095f21.JPG";